import { SITE_IMAGES } from "src/config/images";
import Header from "./header";
import PageHeader from "./page-header";

// Шапка внутренних страниц с фоновым фото (как главный экран на "/"):
// фото + затемнение + меню + заголовок.
// Фото меняется в src/config/images.js (ключ pageTop).
export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image = SITE_IMAGES.pageTop,
}) {
  return (
    <section className="relative w-full">
      {/* photo-fade-bottom — низ фото растворяется, чтобы не было резкой границы */}
      <img
        src={image}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover photo-fade-bottom"
      />
      {/* затемнение, чтобы текст читался и низ уходил в цвет страницы */}
      <div className="absolute inset-0 bg-gradient-to-b from-kj-dark/70 via-kj-dark/50 to-kj-dark" />

      <div className="relative z-10 max-w-[1526px] w-full mx-auto px-4 pb-6 sm:pb-14">
        <Header />
        {title && (
          <div className="pt-10 sm:pt-16">
            <PageHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />
          </div>
        )}
      </div>
    </section>
  );
}
